angular.module('TetherApp').controller('GiftWithPurchasePrizingController', [
    'formService',
    'datepickerService',
    function (formService) {
        let input = formService.getInput();
        let oldInput = formService.getOldInput();
        let errors = formService.getErrors();
        let populate = formService.getPopulate();

        let inputToPass = (input !== undefined) ? input : oldInput;
        let prizePools = (inputToPass !== undefined && inputToPass.hasOwnProperty('prize_pools'))
            ? inputToPass.prize_pools
            : undefined;
        inputToPass = (prizePools !== undefined && prizePools.length > 0)
            ? prizePools[0]
            : undefined;

        this.form = formService.getTemplate(
            errors,
            inputToPass,
            populate,
            'giftWithPurchasePrizing'
        );

        let initPrizePools = function() {
            if (prizePools == undefined) {
                prizePools = [];
                prizePools.push({
                    name: '',
                    class: '',
                    js_hook: '',
                    winner_page_html: '',
                    winner_page_html_fr: '',
                    winner_email_title: '',
                    winner_email_html: '',
                    winner_email_title_fr: '',
                    winner_email_html_fr: ''
                });
            }
        }();
        this.prizePools = prizePools;

        //SET PRIZE POOL DROP DOWN MODELS
        let options = [];
        let fillOptions = function() {
            let newOptions = [];
            for(let index in prizePools) {
                newOptions.push({
                    name: (prizePools[index].name == '')
                        ? 'Create New Prize Pool'
                        : prizePools[index].name,
                    value: index
                });
            }
            options = newOptions;
        }();

        this.options = options;
        //SET DEFAULT PRIZE POOL DROP DOWN VALUE
        this.selected = (options.length > 0) ? options[0] : null;

        /**
         * Update form based on drop down value
         * @param form
         * @param selected
         * @returns {*}
         */
        this.update = function(form, selected) {
            form = formService.getTemplate(
                errors,
                prizePools[selected.value],
                populate,
                'giftWithPurchasePrizing'
            );
            return form;
        };

        this.updateOptions = function(index, value) {
            this.options[index].name = value;
        };

        /**
         * Update prize pools
         * @param index
         * @param name
         * @param model
         */
        this.updatePrizePools = function(index, name, model) {
            if (typeof model === 'object' && model.hasOwnProperty('value')) {
                this.prizePools[index][name] = model.value;
            } else {
                this.prizePools[index][name] = model;
            }
        };

    }
]);
